import axios from "axios";
import { history } from "../../../History";
import config from "../../../config/api";
import { message } from "antd";
import { togglePreloader } from "../App/AppActions";
import { resetAuthReducer } from "../Auth/AuthActions";

export const setAllUsers = (data) => ({
  type: "SET_ALL_USERS",
  data,
});

export const changeUserData = (data) => ({
  type: "CHANGE_USER_DATA",
  data,
});

export const updateNewUserRole = (data) => ({
  type: "UPDATE_NEW_USER_ROLE",
  data,
});

export const setCurrentListPage = (data) => ({
  type: "SET_CURRENT_LIST_PAGE",
  data,
});

export const resetEditUserData = () => ({
  type: "RESET_EDIT_USER_DATA",
});

export const setSearchText = (data) => ({
  type: "SET_SEARCH_TEXT",
  data,
});

export const setSearchResults = (data) => ({
  type: "SET_SEARCH_RESULTS",
  data,
});

export const resetUserReducer = () => ({
  type: "RESET_USER_REDUCER",
});

export const resetSearchData = () => ({
  type: "RESET_SEARCH_DATA",
});

export const setAddingUserStatus = (data) => ({
  type: "SET_ADDING_USER_STATUS",
  data,
});

export const fetchAllUsers = () => {
  return function (dispatch) {
    dispatch(togglePreloader(true));
    if (sessionStorage.getItem("user") === null) {
      localStorage.clear();
    }

    const token = JSON.parse(sessionStorage.getItem("user")).data.token;
    const email = JSON.parse(sessionStorage.getItem("user")).data.email;
    const role = JSON.parse(sessionStorage.getItem("user")).data.role;
    const form_data = {
      auth: { key: token },
      cmd: "user:list",
      authUser: {
        role,
        email,
      },
    };

    axios({
      method: "post",
      url: `${config.api_url}`,
      data: form_data,
    })
      .then((response) => {
        if (response.data.reply.code === 200) {
          dispatch(togglePreloader(false));
          dispatch(setAllUsers(response.data.reply.message));
        } else if (
          response.data.reply.code === 401 ||
          response.data.reply.code === 403
        ) {
          dispatch(togglePreloader(false));
          dispatch(resetUserReducer());
          dispatch(resetAuthReducer());
          history.push("/");
        }
      })
      .catch((error) => {
        dispatch(togglePreloader(false));
        console.log(error);
      });
  };
};

export const addNewUser = (email, role) => {
  return function (dispatch) {
    dispatch(setAddingUserStatus(true));
    const token = JSON.parse(sessionStorage.getItem("user")).data.token;
    const LoggedIn_email = JSON.parse(sessionStorage.getItem("user")).data
      .email;
    const LoggedIn_role = JSON.parse(sessionStorage.getItem("user")).data.role;
    console.log("value of dispatch= ", email, role);
    const form_data = {
      cmd: "user:add",
      auth: { key: token },
      email: email,
      role: role,
      authUser: {
        LoggedIn_role,
        LoggedIn_email,
      },
    };
    axios({
      method: "post",
      url: `${config.api_url}`,
      data: form_data,
    })
      .then((response) => {
        console.log(response);
        if (response.data.reply.code === 200) {
          dispatch(setAddingUserStatus(false));
          message.success(response.data.reply.message);
        } else if (
          response.data.reply.code === 401 ||
          response.data.reply.code === 403
        ) {
          dispatch(setAddingUserStatus(false));
          dispatch(resetUserReducer());
          dispatch(resetAuthReducer());
          message.error("You have been logged out! Please login to continue");
          history.push("/");
        }
      })
      .catch((error) => {
        dispatch(setAddingUserStatus(false));
        console.log(error);
      });
  };
};

export const updateExistingUser = (edit_data) => {
  return function (dispatch) {
    dispatch(togglePreloader(true));
    const token = JSON.parse(sessionStorage.getItem("user")).data.token;
    const email = JSON.parse(sessionStorage.getItem("user")).data.email;
    const role = JSON.parse(sessionStorage.getItem("user")).data.role;
    const form_data = {
      cmd: "user:update",
      auth: { key: token },
      name: edit_data.name,
      role: edit_data.role,
      email: edit_data.email,
      active: edit_data.active,
      authUser: {
        role,
        email,
      },
    };
    axios({
      method: "post",
      url: `${config.api_url}`,
      data: form_data,
    })
      .then((response) => {
        console.log(response);
        if (response.data.reply.code === 200) {
          dispatch(togglePreloader(false));
          message.success(response.data.reply.message);
          dispatch(resetEditUserData());
          dispatch(resetSearchData());
          dispatch(fetchAllUsers());
        } else if (response.data.reply.code === 304) {
          dispatch(togglePreloader(false));
          message.warning(response.data.reply.message);
          dispatch(resetEditUserData());
          dispatch(resetSearchData());
          dispatch(fetchAllUsers());
        } else if (
          response.data.reply.code === 401 ||
          response.data.reply.code === 403
        ) {
          dispatch(togglePreloader(false));
          dispatch(resetEditUserData());
          dispatch(resetUserReducer());
          dispatch(resetSearchData());
          dispatch(resetAuthReducer());
          history.push("/");
          message.error("You have been logged out! Please login to continue");
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };
};



// WEBPACK FOOTER //
// ./src/redux/actions/Users/UsersActions.js